<div class="form-container">
    <notes-reference-settings
        *ngIf="!hideReference"
        [addNumbering]="addNumbering"
        [disabled]="!(title || titleControl?.value)"
        (onBtnClick)="openReferenceDialog()"
        (onAddNumberToggleChange)="onAddNumberToggleChange($event)"
    ></notes-reference-settings>
    <div class="form-container__title">
        <aum-input [placeholder]="'aumico_notes_title' | i18next" [aumFormControl]="titleControl"></aum-input>
    </div>

    <div class="form-container__toggle" *ngIf="!hideTotalToggle">
        <aum-switch-toggle [checked]="checked" (toggle)="toggleChange($event)"></aum-switch-toggle>
        <span>{{ 'aumico_notes_total_row' | i18next }}</span>
    </div>
</div>
